window.$utils = {
  isMac: /macintosh|mac os x/i.test(navigator.userAgent)
}
